module.exports = __webpack_public_path__ + "static/media/ton-pagina-adesao-2.8e0c1839.svg";